import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { createApiClient } from "./api/client";
import { createFirebaseAuthClient } from "./auth/auth-client";
import { AppProviders } from "./app/providers";
import { createAppRouter } from "./app/router";
import { ConfigError, loadConfig } from "./config/env";
import type { AppConfig } from "./config/env";
import "./design/global.css";
import { ConfigErrorPage } from "./pages/errors/ConfigErrorPage";

const container = document.getElementById("root");
if (!container) throw new Error("ThyroAID: #root element missing from index.html");
const root = createRoot(container);

let config: AppConfig | undefined;
try {
  config = loadConfig(import.meta.env);
} catch (error) {
  if (!(error instanceof ConfigError)) throw error;
  console.error(error.message); // operators: the full problem list
  root.render(<ConfigErrorPage problems={error.problems} />);
}

if (config) {
  const authClient = createFirebaseAuthClient(config.firebase);
  const apiClient = createApiClient({
    baseUrl: config.apiBaseUrl,
    getAuthToken: () => authClient.getIdToken(),
  });
  const router = createAppRouter();
  root.render(
    <StrictMode>
      <AppProviders apiClient={apiClient} authClient={authClient}>
        <RouterProvider router={router} />
      </AppProviders>
    </StrictMode>,
  );
}
